<div class="spinner">
	<div class="animated fadeIn">
		<div class="spinner__icon loading">
			<svg class="spinner__svg-circular" viewBox="25 25 50 50">
				<circle class="spinner__svg-path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
			</svg>
		</div>
		<h3 *ngIf="message">{{ message }}</h3>
	</div>
</div>
